import { UtilityServices } from './../../../../Services/utility.services';
import { progressStepNames } from './../../../../Models/progress-bar-step';
import { SecureStorageService } from './../../../../Services/secure-storage.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { NgxSpinnerService } from 'ngx-spinner';
import { AppsettingService } from '../../../../Services/appsetting.service';
import { DealerAdviceService } from '../../../../Services/dealer-advice.service';
import { checkInKeys, localStorageKeys, screenDetails } from '../../../../Models/configurations';

@Component({
  selector: 'app-fifth-step',
  templateUrl: './fifth-step.component.html',
  //styleUrls: ['./fifth-step.component.css']
})
export class FifthStepComponent implements OnInit {
  urlName: string;
  dyServiceList: any;
  dealerId: string;
  public activeStep: number;

  private selectedServicesArrary: any = [];
  private ItemIds: any = [];
  private ItemValues: any = [];
  private ServiceDetails: any = [];
  public steps: any;
  public activeStepName: string;
  public activeStepCompleted: boolean;
  public currencySymbol:string;

  constructor(
    private readonly utilityService: UtilityServices,
    private readonly appsettingService: AppsettingService,
    private readonly dealerAdviceService: DealerAdviceService,
    private readonly secureStorageService: SecureStorageService,
    private spinner: NgxSpinnerService,
    private cdrf: ChangeDetectorRef
  ) {
    if (this.secureStorageService.getKeyData(localStorageKeys.stepStatus) !== undefined) {
      this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    }
    this.currencySymbol=this.secureStorageService.getKeyData(localStorageKeys.currencyType);
  }

  private getDyServiceList(): void {
    this.spinner.show();
    this.dealerAdviceService.getDealerAdviceMasterData()
      .subscribe(
        res => {
          this.dyServiceList = res;
        },
        err => {},
        () => {
          this.spinner.hide();
        }
      );
  }

  public moveNext(): void {
    this.urlName = this.appsettingService.getScreenConfiguration(screenDetails.stepFive);
    this.optimizeCustomerAdvice();
    this.activeStepCompleted = true;
    this.activeStepName = progressStepNames.stepName4;
    this.appsettingService.stepCompletion(this.activeStepName, this.activeStepCompleted);
    this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    this.cdrf.detectChanges();
    this.utilityService.navigateToNext(this.urlName);
  }

   selectedServices(data: any) {
    this.selectedServicesArrary = data;
  }

  private optimizeCustomerAdvice() {
    this.selectedServicesArrary.forEach(element => {
      const item={id:0,price:0}
      item.id = Number(element.itemId)
      item.price = Number(element.itemValue)
      this.ServiceDetails.push(item)
      this.ItemValues.push(Number(element.itemValue));
      this.ItemIds.push(Number(element.itemId));
    });
    const adviceData = {
      ItemIds: this.ItemIds,
      ItemValues: this.ItemValues,
      ServiceDetails: this.ServiceDetails
    };
    this.secureStorageService.setKeyData(localStorageKeys.serviceDetails, adviceData);
  }

  ngOnInit(): void {
    this.getDyServiceList();
  }

}
